<template>
  <div class="mask"></div>
</template>
<script>
import getToken from "@/utils/getToken";
import { mapMutations } from "vuex";
export default {
  name: "introduction",
  created() {
    getToken().then((token) => {
      if (token) {
        this.redirectPage(token);
      } else {
        window.dhsdk.startLogin();
      }
    });
  },
  methods: {
    ...mapMutations({
      changeLoading: "changeLoading",
    }),
    getQueryVariable(variable) {
      if (!location.hash.includes("?")) {
        return false;
      }
      var query = window.location.hash.split("?")[1];
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return false;
    },
    redirectPage(token) {
      this.changeLoading(true);
      let params = {};
      if (this.getQueryVariable("from")) {
        params.from = this.getQueryVariable("from");
      }
      this.$api.my
        .introductionEntry(params, {
          tal_token: token,
        })
        .then((res) => {
          if (res.error_code == 0) {
            window.location.replace(res.result.jump_url);
          } else {
            setTimeout(() => {
              this.redirectPage();
            }, 1500);
          }
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.mask {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: #fff;
}
</style>